import { Button } from '@chakra-ui/react';

import { Box, Flex, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { IoChevronDownOutline } from "react-icons/io5";


export default function DsrInvitedUserOptionsButton({
  userId,
  role,
  handleRemoveUserAccess,
  isMobileView
}) {

  return (
    <Flex align='center'>
      <Menu closeOnSelect={true} placement="bottom-end">
        <MenuButton
          as={Button}
          py="9px"
          px="12px"
          w={isMobileView ? "6em" : "8em"}
          fontSize="0.875em"
          padding={isMobileView ? "1em 0.6em" : "1em 0.75em"}
          background="gray.100"
          border="1px solid #CBD5E0"
          {...{
            rightIcon: <IoChevronDownOutline />
          }}
        >
          <Box className='chosen-option-text-display' color='gray.600'>Invited</Box>
        </MenuButton>
        <MenuList minWidth="8em" >
          <MenuItem >
            <Box className='member-role-options-dropdown-menu__dropdown-option-display' onClick={() => handleRemoveUserAccess(userId, role)}>
              Remove Access
            </Box>
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );

}